module.exports = __webpack_public_path__ + "static/media/male-yellow.a0886db4.png";